export const Projects = [
  {
    stack: ["all", "react"],
    name: "House Marketplace",
    image:
      "https://res.cloudinary.com/trive/image/upload/f_auto,q_auto:eco/v1645779035/house.png",
    description:
      "A web app for users to register and list their apartments/homes for rent/sale. People who are interested can also reach out to the landlords personally. There are also offers on some listings with reasonable discounts.",
    tools: ["ReactJs", "Firebase", "Leaflet", "Swiper", "CSS3"],
    github: "https://github.com/ccanyanwu/HOUSE-LISTINGS-APP",
    live: "https://housemarketplace.netlify.app",
  },
  {
    stack: ["all", "react"],
    name: "Muvlist",
    image:
      "https://res.cloudinary.com/trive/image/upload/f_auto,q_auto:eco/v1645783870/muvlist.png",
    description:
      "Muvlist helps you find the latest trending and popular movies. I used theMovieDataBase api to fetch movie details. I was always undecided on what movie to watch when I want to relax for the weekends and this helped me fix that problem and gain more mastery with react and the react custom hooks",
    tools: ["ReactJs", "Axios", "CSS3"],
    github: "https://github.com/ccanyanwu/MOVIE-LISTING-APP-REACT-",
    live: "https://muvlist.netlify.app",
  },
  {
    stack: ["all", "react"],
    name: "Github Finder",
    image:
      "https://res.cloudinary.com/trive/image/upload/f_auto,q_auto:eco/v1645784692/github.png",
    description:
      "Github finder helps users get the info of any person registered on Github by simply typing in their username. This project helped me understand the usage of the contextAPI and useReducer hook for state management. ",
    tools: ["ReactJs", "Tailwind CSS", "Axios", "GithubRESTAPI"],
    github: "https://github.com/ccanyanwu/GITHUB-FINDER-APP---REACT",
    live: "https://githubidentifier.netlify.app",
  },
  {
    stack: ["all", "javascript"],
    name: "Fido Poultry",
    image:
      "https://res.cloudinary.com/trive/image/upload/f_auto,q_auto:eco/v1645785611/fido.png",
    description:
      "With Fido Poultry Management System app, farm owners no longer have to worry about losses in the business and livestock as everything is duly accounted for daily. This project was built with vanilla javascript and exercised the power of the browser's local storage for storing data.",
    tools: ["Javascript", "CSS3"],
    github: "https://github.com/ccanyanwu/FIDO-POULTRY",
    live: "https://fidopoultry.netlify.app",
  },
  {
    stack: ["all", "node"],
    name: "Expenditure Tracker",
    image:
      "https://res.cloudinary.com/trive/image/upload/f_auto,q_auto:eco/v1645786473/expenditure.png",
    description:
      "Expenditure tracker app helps managers in the company's  departments manage and keep a record of all company expenses spent by employees. The type of expense, category, date, time and much more can be tracked by managers using this app.",
    tools: ["NodeJS", "ExpressJs", "Bootstrap"],
    github: "https://github.com/ccanyanwu/EXPENSE-TRACKING-APPLICATION",
    live: "https://expendituretracker.herokuapp.com/",
  },
  {
    stack: ["all", "javascript"],
    name: "Football Quiz",
    image:
      "https://res.cloudinary.com/trive/image/upload/f_auto,q_auto:eco/v1645787835/football.png",
    description:
      "A simple football quiz app built with javascript that tries to mimic single page application behaviour. It was one of my earliest javascript prjects that taught me a lot about the capabilities of javascript.",
    tools: ["javaScript", "CSS3"],
    github: "https://github.com/ccanyanwu/FOOTBALL-QUIZ-APP",
    live: "https://ccanyanwu.github.io/FOOTBALL-QUIZ-APP/",
  },
  {
    stack: ["all", "javascript"],
    name: "Quik Calc",
    image:
      "https://res.cloudinary.com/trive/image/upload/f_auto,q_auto:eco/v1645788240/calculator.png",
    description:
      "Quik Calc can be used in performing basic mathematical operations such as addition, division, multiplication and subtraction. On an attempt to make wrong operations, an error is displayed to the user for a few seconds.",
    tools: ["javaScript", "CSS3"],
    github:
      "https://github.com/ccanyanwu/IGhub-Frontend-Assignment-/tree/Calcagba",
    live: "https://quikcalc.netlify.app",
  },
  {
    stack: ["all", "html"],
    name: "Heavyweight",
    image:
      "https://res.cloudinary.com/trive/image/upload/f_auto,q_auto:eco/v1645814385/heavyweight.jpg",
    description:
      "Heavyweight landing page is a pixel perfect clone of the famous heavyweight intuitive interfaces for startup website (https://heavyweight.nl) landing page. Built with bootstrap, this project really improved my knowledge of handling lay out for webpages and responsive web design too.",
    tools: ["html", "Bootstrap"],
    github:
      "https://github.com/ccanyanwu/IGhub-Frontend-Assignment-/tree/heavyWeight",
    live: "https://heavyweight.netlify.app",
  },
  {
    stack: ["all", "html"],
    name: "Hi-Praise Table Water",
    image:
      "https://res.cloudinary.com/trive/image/upload/f_auto,q_auto:eco/v1645812665/hi-praise.png",
    description:
      "This project was born out of the desire to give a local business that has been in existence for 16 years an online presence. With this webpage, customers can place their order after going through the company's products. The location on the map is also available for easy direction to the physical facility.",
    tools: ["html", "CSS3", "AOS"],
    github: "https://github.com/ccanyanwu/Hi-praise",
    live: "https://hi-praise.netlify.app",
  },
];

